import React from 'react';
import './Ticker.css';

const items = [
  'Instagram Reels',
  'YouTube Shorts',
  'Brand Films',
  'Event Coverage',
  'Wedding Reels',
  'Product Shoots',
  'Corporate Videos',
  'Capture Moments. Anytime, Anywhere.',
];

const Ticker = () => {
  const doubled = [...items, ...items];

  return (
    <div className="ticker">
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <div key={i} className="ticker-item">
            <span className="td" />
            {i === 7 || i === 15 ? <strong>{item}</strong> : item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
